import React from 'react';
import Header from './Components/Header'
import Main from './Components/Main'
import './main.css'

function App() {
  return (
    <div className="App">
      <Header/>
      <Main/>
    </div>
  );
}

export default App;
